"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Button = _interopRequireDefault(require("../Button"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownMenu = ({
  icon,
  className,
  children
}) => {
  const [open, setOpen] = (0, _react.useState)(false);
  const dropdownRef = _react.default.useRef(null);
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      setTimeout(() => {
        setOpen(false);
      }, 200);
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);
  (0, _react.useEffect)(() => {
    if (!dropdownRef?.current) return;
    if (open) {
      // Focus the first focusable element in the dropdown when it opens
      const focusableElements = dropdownRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length) {
        const element = focusableElements[0];
        element.focus();
      }
    }
  }, [open]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      "aria-haspopup": true,
      "aria-expanded": open,
      nostyle: true,
      focusable: true,
      onClick: () => setOpen(!open),
      trackingEvent: "DropdownMenu toggle",
      trackingName: "Topbar",
      children: icon ? icon : ''
    }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Content, {
      ref: dropdownRef,
      role: "menu",
      children: children
    })]
  });
};
var _default = exports.default = DropdownMenu;